//----------------------------------
// Imports
//----------------------------------
import Vue from 'vue';
// import Modal from '@/components/ui/Modal';

//----------------------------------
// Private Variables
//----------------------------------
let vuePlugins = {};
let vmOverlay = null;

export default class VueUtil {
  //----------------------------------
  // Getter Setter
  //----------------------------------
  static set plugins(value) {
    vuePlugins = value;
  }

  static set overlay(value) {
    vmOverlay = value;
  }

  static get plugins() {
    return vuePlugins;
  }

  //----------------------------------
  // Public Static Methods
  //----------------------------------
  static createComponent(component, target, props = null) {
    const ComponentCtor = Vue.extend(component);
    const vm = new ComponentCtor({ ...vuePlugins, ...props });
    vm.$mount();
    target.appendChild(vm.$el);
    return vm;
  }

  static showOverlay(name) {
    vmOverlay.show(name);
  }
}
